import axiosIns from 'utils/axios'
let epmbase = 'EPM-BASE-SERVICE'

// 获取整棵树
export function getWholeTree (rootId) {
  return axiosIns({
    url: `/api/pc/mptt/getWholeTree/${rootId}`,
    method: 'get',
    owner: epmbase
  }).then(res => {
    // let arr = new Array();
    let arr = res.data
    f(arr, 0)
    return arr
  })
}

function f (arr, pid) {
  // if (arr) {
    console.log('集合',arr);
    arr.forEach((item, index) => {
      item.name = item.relationId
      item.parent_id = pid
      item.order = index
      item.url = ''
      item.lists = item.mpttVOList
      item.isShowCheckbox = false
      item.highlight = false
      // item.id = index
      if (item.mpttVOList && item.mpttVOList.length > 0) {
        f(item.mpttVOList, item.id)
      }
    })
  // }
}

// 新赠节点
export function addNode (data) {
  return axiosIns({
    headers: { 'content-type': 'application/json;charset=UTF-8' },
    url: `/api/pc/mptt/addNode`,
    owner: epmbase,
    method: 'put',
    data: data
  })
}
// 移除某节点下的所有子节点（含该节点）
export function removeNode (data) {
  return axiosIns({
    headers: { 'content-type': 'application/json;charset=UTF-8' },
    url: `/api/pc/mptt/removeNode`,
    owner: epmbase,
    method: 'put',
    data: data
  })
}

// 移动节点
export function moveNode (data) {
  return axiosIns({
    headers: { 'content-type': 'application/json;charset=UTF-8' },
    url: `/api/pc/mptt/moveNode`,
    owner: epmbase,
    method: 'put',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/views/system-manage/treeTable/treeTableAPI.js